import { render, staticRenderFns } from "./KeyboardShortcutsOverlay.vue?vue&type=template&id=29d98cb8&scoped=true&"
import script from "./KeyboardShortcutsOverlay.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcutsOverlay.vue?vue&type=style&index=0&id=29d98cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d98cb8",
  null
  
)

export default component.exports